import { DEFAULT_PRODUCTION_API_URL } from './productionApiUrl.js'

export const API_URL =
	import.meta.env.VITE_API_URL ||
	(import.meta.env.DEV ? 'http://localhost:4000' : DEFAULT_PRODUCTION_API_URL)
